import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import styled from 'styled-components';

import { ReactComponent as Logo } from 'asserts/logo/logo_exbody.svg';
import { ReactComponent as Badge } from 'asserts/icons/Badge_Biz.svg';

import LoginFooter from 'components/footer/LoginFooter';
import { Link } from 'react-router-dom';

interface JoinLayoutProps {
  text: string;
  children: React.ReactNode;
}

const JoinLayout = ({ text, children }: JoinLayoutProps) => {
  return (
    <Wrapper>
      <InnerWrapper>
        <LogoWrapper>
          <Link to="/">
            <Logo fill="#000" />
          </Link>
          <Badge />
        </LogoWrapper>
        <ContentsWrapper>
          <div className="logo">
            <img src="/images/login_logo.png" alt="logo" />
            <div>
              <h2>BIZ Membership</h2>
              <h3>{text}</h3>
            </div>
          </div>
          {children}
        </ContentsWrapper>
      </InnerWrapper>
      <LoginFooter />
    </Wrapper>
  );
};

export default JoinLayout;

const Wrapper = styled.div`
  width: 100%;
  background: ${color.blue50};
`;

const InnerWrapper = styled.div`
  position: relative;
  max-width: 1440px;
  miin-width: 1280px;
  height: 900px;
  margin: 0 auto;
  padding: 48px 48px 0;

  h2 {
    color: ${color.navyLight};
    ${font.d1_bold};
  }

  h3 {
    padding: 16px 0 48px;
    color: ${color.navyLight};
    ${font.h1_medium};
  }

  p {
    color: ${color.black2};
    font-size: 20px;
    line-height: 24px;
  }

  & section {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  a {
    cursor: pointer;
    width: 120px;
    height: 38px;
    margin-top: 8px;
  }

  a svg {
    opacity: 0.4;
  }
`;

const ContentsWrapper = styled.div`
  position: absolute;
  left: 275px;
  top: 160px;

  div.logo {
    display: flex;
    flex-direction: column;
    gap: 48px;

    img {
      width: 371px;
      height: 140px;
    }
  }
`;
